import api from "../../utils/api";
import dayjs from "dayjs";
const qs = require("qs");

function buildFullAddress(deal) {
  var addr = deal.address || "";
  var parts = [];
  if (deal.buildingDong) parts.push(deal.buildingDong);
  if (deal.buildingHo) {
    var h = deal.buildingHo;
    parts.push(h.endsWith("호") ? h : h + "호");
  }
  if (parts.length > 0) {
    addr += " " + parts.join(" ");
  } else if (deal.addressDetail) {
    addr += " " + deal.addressDetail;
  }
  return addr;
}

const state = {
  _directDeals: [],
  _page: {},
  _currentDeal: null,
};

const mutations = {
  setDirectDealList(state, { items, users, page }) {
    const mapped = items.map(deal => {
      const userItem = users.find(u => u.userNo && u.userNo.includes(deal.userNo));
      return {
        directDealSeq: deal.directDealSeq,
        userNo: deal.userNo,
        dealRole: deal.dealRole,
        status: deal.status,
        applicantName: deal.applicantName || "",
        applicantPhone: deal.applicantPhone || "",
        email: userItem ? userItem.email : "",
        address: buildFullAddress(deal),
        createDate: deal.createDate ? dayjs(deal.createDate).format("YYYY.MM.DD. a h:mm:ss") : "",
      };
    });
    state._directDeals = [];
    state._directDeals = [...mapped];
    state._page = {};
    state._page = page;
  },
  setDirectDealDetail(state, data) {
    state._currentDeal = data;
  },
};

const actions = {
  async acDirectDealList({ commit }, { email, status, page, pageSize }) {
    try {
      let userNo = null;

      // 이메일로 검색할 경우 먼저 회원 API에서 userNo 찾기
      if (email) {
        const userRes = await api.get(`/api/v1/user-info`, {
          params: { email },
        });
        if (userRes.data && userRes.data.data && userRes.data.data.userNo) {
          userNo = userRes.data.data.userNo;
        } else {
          // 이메일에 해당하는 회원이 없으면 빈 결과
          commit("setDirectDealList", { items: [], users: [], page: { pageSize, totalCount: 0, totalPage: 0 } });
          return null;
        }
      }

      // 직거래 리스트 호출
      const queries = { userNo, status, page, pageSize };
      const res = await api.get(`/api/v1/direct-deal/admin/list`, { params: queries });

      const data = res.data.data;
      const items = data.items || [];

      // userNo 목록 추출 후 회원 정보 조회
      const userNos = [...new Set(items.map(item => item.userNo))];
      let users = [];
      if (userNos.length > 0) {
        const userRes = await api.get(`/api/v1/user/admin/order-user`, {
          params: { members: userNos },
          paramsSerializer: {
            serialize: params => qs.stringify(params, { arrayFormat: "repeat" }),
          },
        });
        users = userRes.data.data || [];
      }

      commit("setDirectDealList", {
        items,
        users,
        page: data.page,
      });

      return res.data;
    } catch (err) {
      console.log("acDirectDealList err", err.message);
      return null;
    }
  },

  async acDirectDealDetail({ commit }, { directDealSeq }) {
    try {
      const res = await api.get(`/api/v1/direct-deal/admin/detail/${directDealSeq}`);
      commit("setDirectDealDetail", res.data.data);
      return res.data;
    } catch (err) {
      console.log("acDirectDealDetail err", err.message);
      return null;
    }
  },

  async acGetRegistryPdfUrl(_, { s3Path }) {
    try {
      const res = await api.get(`/api/v1/direct-deal/admin/registry-pdf-url`, {
        params: { s3Path },
      });
      return res.data?.data?.url || null;
    } catch (err) {
      console.log("acGetRegistryPdfUrl err", err.message);
      return null;
    }
  },

  async acUpdateStatus(_, { directDealSeq, status }) {
    try {
      const res = await api.patch(`/api/v1/direct-deal/admin/${directDealSeq}/status`, { status });
      return res.data;
    } catch (err) {
      console.log("acUpdateStatus err", err.message);
      return null;
    }
  },

  async acUploadRegistry(_, { directDealSeq, file }) {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await api.post(`/api/v1/direct-deal/admin/${directDealSeq}/registry-upload`, formData);
      return res.data;
    } catch (err) {
      console.log("acUploadRegistry err", err.message);
      return null;
    }
  },

  async acDeleteDeal(_, { directDealSeq }) {
    try {
      const res = await api.delete(`/api/v1/direct-deal/admin/${directDealSeq}`);
      return res.data;
    } catch (err) {
      console.log("acDeleteDeal err", err.message);
      return null;
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
